<template>
  <div class="c-aed-contactInformation">
    <div
      class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border"
    >
      {{ translationsContactInformation.sectionName || name }}
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsCustom.firstName || ''">{{
            translationsCustom.firstName || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="firstName"
            :value="(contactInformation && contactInformation.firstName) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsCustom.lastName || ''">{{
            translationsCustom.lastName || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="lastName"
            :value="(contactInformation && contactInformation.lastName) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsCustom.email || ''">{{
            translationsCustom.email || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="email"
            type="email"
            :value="(contactInformation && contactInformation.email) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsCustom.ccEmail || ''">{{
            translationsCustom.ccEmail || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="ccEmail"
            type="email"
            :allowEmpty="true"
            :value="(contactInformation && contactInformation.ccEmail) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsCustom.mobile || ''">{{
            translationsCustom.mobile || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="mobile"
            type="tel"
            :value="(contactInformation && contactInformation.mobile) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--6">
          <span class="o-label" :title="translationsCustom.primary || ''">{{
            translationsCustom.primary || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <CallCenterAEDeditableInput
            :section="section"
            name="primaryPhone"
            type="tel"
            :value="
              (contactInformation && contactInformation.primaryPhone) || ''
            "
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    ></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "c-aed-contactInformation",
  data() {
    return {
      section: "fadder",
      name: "Kontaktinformation"
    };
  },

  computed: {
    ...mapState("translations", {
      translationsContactInformation: "fadder",
      translationsCustom: "custom"
    }),
    ...mapGetters("aed", {
      contactInformation: "fadder"
    })
  }
};
</script>
<style lang="scss">
.c-aed-contactInformation {
}
</style>
